export class ClienteViewModel {
    id: string;
    razonSocial: string;
    codigo: string;
    cuit: string;
    email: string;
    confirmoEmail: boolean;
    transporteInicialDebito: number;
    transporteInicialCredito: number;
    saldoFinal: number;
    solicitaConfirmacionLectura: boolean;
    ultimoEnvioInforme: Date;
    cuentaDolares: boolean;
    saldoInicialPesos: number;
    saldoInicialDolares: number;
    activo: boolean;
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/models/viewmodels/ClienteViewModel.ts